import React from "react";
import { Checkbox, Dropdown, Form, Header, Input } from "semantic-ui-react";

import { RootState } from "../../store/SrciStore";
import { save } from "../../store/reducers/SrciInputData";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import ArrayToUiList from "../../helpers/ArrayToUIList";

export default function CTP() {

  const countryCodes = ArrayToUiList([{key: "EMPTY", text: "- EMPTY -", value: ""}, "GB", "SE", "PL"])
  const dpaAcceptedBillingCountries = ArrayToUiList(["GB", "SE", "PL"])
  const dpaAcceptedShippingCountries = ArrayToUiList(["GB", "SE", "PL"])

  const dpaBillingPreferenceMc = [
    { key: "FULL", text: "FULL", value: "FULL" },
    { key: "POSTAL_COUNTRY", text: "POSTAL_COUNTRY", value: "POSTAL_COUNTRY" },
    { key: "NONE", text: "NONE", value: "NONE" }
  ]

  const dpaShippingPreferenceMc = [
    { key: "FULL", text: "FULL", value: "FULL" },
    { key: "NONE", text: "NONE", value: "NONE" }
  ]

  const dpaBillingPreferenceVisa = [
    { key: "ALL", text: "ALL", value: "ALL" },
    { key: "POSTAL_COUNTRY", text: "POSTAL_COUNTRY", value: "POSTAL_COUNTRY" },
    { key: "NONE", text: "NONE", value: "NONE" }
  ]

  const dpaShippingPreferenceVisa = [
    { key: "ALL", text: "ALL", value: "ALL" },
    { key: "POSTAL_COUNTRY", text: "POSTAL_COUNTRY", value: "POSTAL_COUNTRY" },
    { key: "NONE", text: "NONE", value: "NONE" }
  ]

  const transactionType = [
    { key: "PURCHASE", text: "PURCHASE", value: "PURCHASE" },
    { key: "BILL_PAYMENT", text: "BILL_PAYMENT", value: "BILL_PAYMENT" },
    { key: "MONEY_TRANSFER", text: "MONEY_TRANSFER", value: "MONEY_TRANSFER" }
  ]

  const reviewActionVisa = [
    { key: "continue", text: "continue", value: "continue" },
    { key: "pay", text: "pay", value: "pay" }
  ]

  const orderTypeVisa = [
    { key: "REAUTHORIZATION", text: "REAUTHORIZATION", value: "REAUTHORIZATION" },
    { key: "RECURRING", text: "RECURRING", value: "RECURRING" },
    { key: "INSTALLMENT", text: "INSTALLMENT", value: "INSTALLMENT" }            
  ]

  const dcfExperienceMc = [
    { key: "WITHIN_CHECKOUT", text: "WITHIN_CHECKOUT", value: "WITHIN_CHECKOUT" },
    { key: "PAYMENT_SETTINGS", text: "PAYMENT_SETTINGS", value: "PAYMENT_SETTINGS" }
  ]

  const srciActionCode = [
    { key: "NEW_USER", text: "NEW_USER", value: "NEW_USER" },
    { key: "AUTH_FAILED", text: "AUTH_FAILED", value: "AUTH_FAILED" },
    { key: "AUTH_SKIPPED", text: "AUTH_SKIPPED", value: "AUTH_SKIPPED" }
  ]
  
  const locale = [
    { key: "EN_CA", text: "EN_CA", value: "en_ca"},
    { key: "FR_CA", text: "FR_CA", value: "fr_ca"},
    { key: "EN_US", text: "EN_US", value: "en_us"},
    { key: "EN_GB", text: "EN_GB", value: "en_gb"},
    { key: "ES_ES", text: "ES_ES", value: "es_es"},
    { key: "EN_ES", text: "EN_ES", value: "en_es"},
    { key: "FR_FR", text: "FR_FR", value: "fr_fr"},
    { key: "EN_FR", text: "EN_FR", value: "en_fr"},
    { key: "EN_IE", text: "EN_IE", value: "en_ie"},
    { key: "DE_DE", text: "DE_DE", value: "de_de"},
    { key: "IT_IT", text: "IT_IT", value: "it_it"},
    { key: "NL_BE", text: "NL_BE", value: "nl_be"},
    { key: "PL_PL", text: "PL_PL", value: "pl_pl"},
    { key: "HR_HR", text: "HR_HR", value: "hr_hr"},
    { key: "SV_SE", text: "SV_SE", value: "sv_se"},
    { key: "UK_UA", text: "UK_UA", value: "uk_ua"},
    { key: "EN_SG", text: "EN_SG", value: "en_sg"},
    { key: "ZH_SG", text: "ZH_SG", value: "zh_sg"},
    { key: "EN_AU", text: "EN_AU", value: "en_au"},
    { key: "EN_NZ", text: "EN_NZ", value: "en_nz"},
    { key: "EN_MY", text: "EN_MY", value: "en_my"},
    { key: "MS_MY", text: "MS_MY", value: "ms_my"},
    { key: "EN_HK", text: "EN_HK", value: "en_hk"},
    { key: "ZH_HK", text: "ZH_HK", value: "zh_hk"},
    { key: "EN_TH", text: "EN_TH", value: "en_th"},
    { key: "EN_AE", text: "EN_AE", value: "en_ae"},
    { key: "AR_AE", text: "AR_AE", value: "ar_ae"},
    { key: "EN_SA", text: "EN_SA", value: "en_sa"},
    { key: "AR_SA", text: "AR_SA", value: "ar_sa"},
    { key: "EN_QA", text: "EN_QA", value: "en_qa"},
    { key: "AR_QA", text: "AR_QA", value: "ar_qa"},
    { key: "EN_KW", text: "EN_KW", value: "en_kw"},
    { key: "AR_KW", text: "AR_KW", value: "ar_kw"},
    { key: "EN_ZA", text: "EN_ZA", value: "en_za"},
    { key: "ZU_ZA", text: "ZU_ZA", value: "zu_za"},
    { key: "ES_MX", text: "ES_MX", value: "es_mx"},
    { key: "PT_BR", text: "PT_BR", value: "pt_br"},
    { key: "ES_PE", text: "ES_PE", value: "es_pe"},
    { key: "ES_CO", text: "ES_CO", value: "es_co"},
    { key: "ES_AR", text: "ES_AR", value: "es_ar"},
    { key: "ES_CL", text: "ES_CL", value: "es_cl"}    
  ]

  const buttonSize = [
    { key: "small", text: "small", value: "small" },
    { key: "medium", text: "medium", value: "medium" },
    { key: "big", text: "big", value: "big" }    
  ]

  const paymentMethod = [
    { key: "MC", text: "MC", value: "master" },
    { key: "VISA", text: "VISA", value: "visa" },
    { key: "MC_VISA", text: "MC_VISA", value: "master,visa" },
    { key: "MC_AMEX", text: "MC_AMEX", value: "master,amex" },
    { key: "MC_VISA_AMEX", text: "MC_VISA_AMEX", value: "master,visa,amex" },
    { key: "MC_AMEX_VISA", text: "MC_AMEX_VISA", value: "master,amex,visa" },
    { key: "MC_VISA_AMEX_DISC", text: "MC_VISA_AMEX_DISC", value: "master,visa,amex,discover" },
    { key: "MC_VISA_DISC_AMEX", text: "MC_VISA_DISC_AMEX", value: "master,visa,discover,amex" },
    { key: "MC_AMEX_VISA_DISC", text: "MC_AMEX_VISA_DISC", value: "master,amex,visa,discover" },
    { key: "MC_AMEX_DISC_VISA", text: "MC_AMEX_DISC_VISA", value: "master,amex,discover,visa" },
    { key: "MC_DISC_VISA_AMEX", text: "MC_DISC_VISA_AMEX", value: "master,discover,visa,amex" },
    { key: "MC_DISC_AMEX_VISA", text: "MC_DISC_AMEX_VISA", value: "master,discover,amex,visa" }
  ]

  const payloadTypeIndicator = [
    { key: "FULL", text: "FULL", value: "FULL" },
    { key: "SUMMARY", text: "SUMMARY", value: "SUMMARY" },
    { key: "PAYMENT", text: "PAYMENT", value: "PAYMENT" },
    { key: "NON_PAYMENT", text: "NON_PAYMENT", value: "NON_PAYMENT" },
    { key: "NONE", text: "NONE", value: "NONE" }
  ]

  const identityType = ArrayToUiList(["EMAIL_ADDRESS", "MOBILE_PHONE_NUMBER"])


  const srciInputData = useAppSelector((state: RootState) => state.srciInputData)
  const srciInitVisa = useAppSelector((state: RootState) => state.srciInputData.srciInitVisa)
  const srciInitMastercard = useAppSelector((state: RootState) => state.srciInputData.srciInitMastercard)
  const billingAddress = useAppSelector((state: RootState) => state.srciInputData.billingAddress)
  const dcfCheckoutParams = useAppSelector((state: RootState) => state.srciInputData.dcfCheckoutParams)
  const buttonParams = useAppSelector((state: RootState) => state.srciInputData.buttonParams)
  const dispatch = useAppDispatch()

  const handleEmailChange = (e: any, element: any) => {
    if(dcfCheckoutParams.consumer.consumerIdentity.identityType === "EMAIL_ADDRESS") {      
      dispatch(save({
        name: "dcfCheckoutParams.consumer.consumerIdentity.identityValue",
        value: element.value
      }))
    }

    dispatch(save({
      name: "dcfCheckoutParams.consumer.emailAddress",
      value: element.value
    }))
  }
  
  const handlePhoneChange = (e: any, element: any) => {
    if(dcfCheckoutParams.consumer.consumerIdentity.identityType === "MOBILE_PHONE_NUMBER") {
      dispatch(save({
        name: "dcfCheckoutParams.consumer.consumerIdentity.identityValue",
        value: dcfCheckoutParams.consumer.mobileNumber.countryCode +""+ element.value
      }))    
    }

    dispatch(save({
      name: "dcfCheckoutParams.consumer.mobileNumber.phoneNumber",
      value: element.value
    }))    
  }

  const handleConfirmPaymentAndDcfExperience = (e: any, element: any) => {
    let customInputData = undefined
    if(element.checked) {
      customInputData = {
        "com.mastercard.dcfExperience" : "PAYMENT_SETTINGS"
      }
    } else {
      customInputData = undefined
    }
    dispatch(save({
      name: "srciInitMastercard.dpaTransactionOptions.customInputData",
      value: customInputData
    }))    
  }

  const handleDcfExperienceChange = (e: any, element: any) => {
    dispatch(save({
      name: "srciInitMastercard.dpaTransactionOptions.customInputData",
      value: { "com.mastercard.dcfExperience": element.value }
    }))     
  }

  const handleOnChange = (e: any, element: any) => {
    if(element.type === "checkbox") {
      element.value = element.checked
    }

    dispatch(save({
      name: element.name,
      value: element.value
    }))
  }

  return (
    <React.Fragment>
      <Form>
        <Header as="h2">SRC Inputs</Header>
        <Form.Group widths='equal'>
          <Form.Field>
            <label>Requested Validation Channel ID</label>
            <Input value={srciInputData.requestedValidationChannelId} name="requestedValidationChannelId" onChange={handleOnChange} />
          </Form.Field>
        </Form.Group>

        <Header as="h2">Address</Header>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Name</label>
                <Input value={billingAddress.name} name="billingAddress.name" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>Line 1</label>
                <Input value={billingAddress.line1} name="billingAddress.line1" onChange={handleOnChange} />
            </Form.Field>     
            <Form.Field>
                <label>Line 2</label>
                <Input value={billingAddress.line2} name="billingAddress.line2" onChange={handleOnChange} />
            </Form.Field>          
            <Form.Field>
                <label>Line 3</label>
                <Input value={billingAddress.line3} name="billingAddress.line3" onChange={handleOnChange} />
            </Form.Field>                                             
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>City</label>
                <Input value={billingAddress.city} name="billingAddress.city" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>State</label>
                <Input value={billingAddress.state} name="billingAddress.state" onChange={handleOnChange} />
            </Form.Field>     
            <Form.Field>
                <label>Zip</label>
                <Input value={billingAddress.zip} name="billingAddress.zip" onChange={handleOnChange} />
            </Form.Field>          
            <Form.Select fluid label="Country Code" options={countryCodes} defaultValue={billingAddress.countryCode} name="billingAddress.countryCode" onChange={handleOnChange} />                                            
        </Form.Group> 

        <Header as="h2">DPA Transaction Options</Header>
        <Form.Group widths='equal'>
          <Form.Field>
                <label>DPA Accepted Billing Countries</label>
                <Dropdown fluid multiple selection options={dpaAcceptedBillingCountries} name="dcfCheckoutParams.dpaTransactionOptions.dpaAcceptedBillingCountries" defaultValue={dcfCheckoutParams.dpaTransactionOptions.dpaAcceptedBillingCountries} onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>DPA Accepted Shipping Countries</label>
                <Dropdown fluid multiple selection options={dpaAcceptedShippingCountries} name="dcfCheckoutParams.dpaTransactionOptions.dpaAcceptedShippingCountries" defaultValue={dcfCheckoutParams.dpaTransactionOptions.dpaAcceptedShippingCountries} onChange={handleOnChange} />
            </Form.Field>     
            <Form.Select fluid label="DPA Billing Preference [MC]" name="srciInitMastercard.dpaTransactionOptions.dpaBillingPreference" options={dpaBillingPreferenceMc} defaultValue={srciInitMastercard.dpaTransactionOptions.dpaBillingPreference} onChange={handleOnChange} />
            <Form.Select fluid label="DPA Shipping Preference [MC]" name="srciInitMastercard.dpaTransactionOptions.dpaShippingPreference" options={dpaShippingPreferenceMc} defaultValue={srciInitMastercard.dpaTransactionOptions.dpaShippingPreference} onChange={handleOnChange} />
        </Form.Group>
        <Form.Group widths='equal'>
          <Form.Select fluid label="DPA Billing Preference [Visa]" name="srciInitVisa.dpaTransactionOptions.dpaBillingPreference" options={dpaBillingPreferenceVisa} defaultValue={srciInitVisa.dpaTransactionOptions.dpaBillingPreference} onChange={handleOnChange} />
          <Form.Select fluid label="DPA Shipping Preference [Visa]" name="srciInitVisa.dpaTransactionOptions.dpaShippingPreference" options={dpaShippingPreferenceVisa} defaultValue={srciInitVisa.dpaTransactionOptions.dpaShippingPreference} onChange={handleOnChange} />          
          <Form.Field>
              <label>DPA Locale</label>
              <Input value="en_GB" />
          </Form.Field>
          <Form.Select fluid label="Transaction Type" options={transactionType} defaultValue={srciInitVisa.dpaTransactionOptions.transactionType} name="srciInitVisa.dpaTransactionOptions.transactionType" onChange={handleOnChange} />             
        </Form.Group>   
        <Form.Group>
          <Form.Select fluid label="Payload Type Indicator" options={payloadTypeIndicator} defaultValue={srciInitVisa.dpaTransactionOptions.payloadTypeIndicator} name="srciInitVisa.dpaTransactionOptions.payloadTypeIndicator" onChange={handleOnChange} />             
        </Form.Group>
        <Form.Group widths='equal'>
          <Form.Field>
            <Checkbox label="Consumer Name Requested" checked={dcfCheckoutParams.dpaTransactionOptions.consumerNameRequested} name="dcfCheckoutParams.dpaTransactionOptions.consumerNameRequested" onChange={handleOnChange} />
          </Form.Field> 
          <Form.Field>
            <Checkbox label="Consumer Email Address Requested" checked={dcfCheckoutParams.dpaTransactionOptions.consumerEmailAddressRequested} name="dcfCheckoutParams.dpaTransactionOptions.consumerEmailAddressRequested" onChange={handleOnChange} />
          </Form.Field> 
          <Form.Field>
            <Checkbox label="Consumer Phone Number Requested" checked={dcfCheckoutParams.dpaTransactionOptions.consumerPhoneNumberRequested} name="dcfCheckoutParams.dpaTransactionOptions.consumerPhoneNumberRequested" onChange={handleOnChange} />
          </Form.Field> 
          <Form.Field>
            <Checkbox label="Is Guest Checkout [MC]" checked={srciInitMastercard.dpaTransactionOptions.isGuestCheckout} name="srciInitMastercard.dpaTransactionOptions.isGuestCheckout" onChange={handleOnChange} />
          </Form.Field>           
        </Form.Group>
        <Form.Group widths='equal'>
          <Form.Field>
            <Checkbox label="Confirm Payment [MC]" checked={srciInitMastercard.dpaTransactionOptions.confirmPayment} name="srciInitMastercard.dpaTransactionOptions.confirmPayment" onChange={handleOnChange} />
          </Form.Field> 
          <Form.Field>
          <Checkbox label="Use Confirm Payment and DCF Experience [MC]" checked={srciInitMastercard.dpaTransactionOptions.customInputData !== undefined} name="confirmPaymentAndDcfExperience" onChange={handleConfirmPaymentAndDcfExperience} />
          </Form.Field> 
          <Form.Select fluid label="Review Action [VISA]" options={reviewActionVisa} defaultValue={srciInitVisa.dpaTransactionOptions.reviewAction} name="srciInitVisa.dpaTransactionOptions.reviewAction" onChange={handleOnChange} />   
          <Form.Field>
              <label>Checkout description [VISA]</label>
              <Input value={srciInitVisa.dpaTransactionOptions.checkoutDescription} name="srciInitVisa.dpaTransactionOptions.checkoutDescription" onChange={handleOnChange} />
          </Form.Field>          
        </Form.Group>   
        <Form.Group widths='equal'>
          <Form.Select fluid label="Order Type [VISA]" options={orderTypeVisa} defaultValue={srciInitVisa.dpaTransactionOptions.orderType} name="srciInitVisa.dpaTransactionOptions.orderType" onChange={handleOnChange} />   
          <Form.Field>
              <label>Merchant Order Id [VISA]</label>
              <Input value={srciInitVisa.dpaTransactionOptions.merchantOrderId} name="srciInitVisa.dpaTransactionOptions.merchantOrderId" onChange={handleOnChange} />
          </Form.Field>   
          <Form.Field>
              <label>Merchant Category Code [VISA]</label>
              <Input value={srciInitVisa.dpaTransactionOptions.merchantCategoryCode} name="srciInitVisa.dpaTransactionOptions.merchantCategoryCode" onChange={handleOnChange} />
          </Form.Field> 
          <Form.Field>
              <label>Merchant Country Code [VISA]</label>
              <Input value={srciInitVisa.dpaTransactionOptions.merchantCountryCode} name="srciInitVisa.dpaTransactionOptions.merchantCountryCode" onChange={handleOnChange} />
          </Form.Field>                            
        </Form.Group>        
        <Form.Group widths='equal'>
          <Form.Select fluid label="DCF Experience [MC]" options={dcfExperienceMc} defaultValue={srciInitMastercard.dpaTransactionOptions.customInputData?.["com.mastercard.dcfExperience"]} onChange={handleDcfExperienceChange} />   
          <Form.Select fluid label="Consumer Identity Type" options={identityType} name="dcfCheckoutParams.consumer.consumerIdentity.identityType" defaultValue={dcfCheckoutParams.consumer.consumerIdentity.identityType} onChange={handleOnChange} disabled />   
          <Form.Field></Form.Field>
          <Form.Field></Form.Field>                          
        </Form.Group>                    

        <Header as="h2">SRC Payment Options</Header>
        <Form.Group widths='equal'>
          <Form.Field>
            <label>DPA Dynamic Data Ttl Minutes</label>
            <Input value={srciInitVisa.dpaTransactionOptions.paymentOptions?.dpaDynamicDataTTLMinutes} name="srciInitVisa.dpaTransactionOptions.paymentOptions.dpaDynamicDataTTLMinutes" onChange={handleOnChange} />
          </Form.Field>           
          <Form.Field>
            <label>Dynamic Data Type [MC]</label>
            <Input value={srciInitMastercard.dpaTransactionOptions.paymentOptions?.dynamicDataType} name="srciInitMastercard.dpaTransactionOptions.paymentOptions.dynamicDataType" onChange={handleOnChange} />
          </Form.Field>           
          <Form.Field>
            <label>Dynamic Data Type</label>
            <Input value={srciInitVisa.dpaTransactionOptions.paymentOptions?.dynamicDataType} name="srciInitVisa.dpaTransactionOptions.paymentOptions.dynamicDataType" onChange={handleOnChange}/>
          </Form.Field> 
          <Form.Field>
            <Checkbox label="Dpa Pan Requested [VISA]" checked={srciInitVisa.dpaTransactionOptions.paymentOptions?.dpaPanRequested} name="srciInitVisa.dpaTransactionOptions.paymentOptions.dpaPanRequested" onChange={handleOnChange} />
          </Form.Field>                          
        </Form.Group>  

        <Header as="h2">DPA Data</Header>
        <Form.Group widths='equal'>
          <Form.Field>
            <label>DPA Presentation Name</label>
            <Input value={srciInitVisa.dpaData?.dpaPresentationName} name="srciInit.dpaData.dpaPresentationName" onChange={handleOnChange} />
          </Form.Field> 
          <Form.Field>
            <label>DPA URI</label>
            <Input value={srciInitVisa.dpaData?.dpaUri} name="srciInit.dpaData.dpaUri" onChange={handleOnChange} />
          </Form.Field> 
          <Form.Field></Form.Field>
          <Form.Field></Form.Field>                          
        </Form.Group>

        <Header as="h2">DCF Checkout</Header>
        <Form.Group widths='equal'>
          <Form.Field>
            <label>Is Recognized DPA Transaction Options</label>
            <Input value={dcfCheckoutParams.isRecognizeddpaTransactionOptions} name="dcfCheckoutParams.isRecognizeddpaTransactionOptions" onChange={handleOnChange} />
          </Form.Field> 
          <Form.Select fluid label="SRCi Action Code" options={srciActionCode} defaultValue={dcfCheckoutParams.srciActionCode} name="dcfCheckoutParams.srciActionCode" onChange={handleOnChange} />   
          <Form.Field>
            <Checkbox label="Enroll Before Checkout" checked={dcfCheckoutParams.enrollBeforeCheckout} name="dcfCheckoutParams.enrollBeforeCheckout" onChange={handleOnChange} />
          </Form.Field>
          <Form.Field></Form.Field>                          
        </Form.Group>  

        <Header as="h2">Consumer</Header>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Email Address</label>
                <Input value={dcfCheckoutParams.consumer.emailAddress} name="dcfCheckoutParams.consumer.emailAddress" onChange={handleEmailChange}/>
            </Form.Field>
            <Form.Field>
                <label>First Name</label>
                <Input value={dcfCheckoutParams.consumer.firstName} name="dcfCheckoutParams.consumer.firstName" onChange={handleOnChange} />
            </Form.Field>     
            <Form.Field>
                <label>Last Name</label>
                <Input value={dcfCheckoutParams.consumer.lastName} name="dcfCheckoutParams.consumer.lastName" onChange={handleOnChange} />
            </Form.Field>                                 
        </Form.Group>
        <Form.Group widths='equal'>
            <Form.Field>
                <label>Phone Calling Code</label>
                <Input value={dcfCheckoutParams.consumer.mobileNumber.countryCode} name="dcfCheckoutParams.consumer.mobileNumber.countryCode" onChange={handleOnChange} />
            </Form.Field>
            <Form.Field>
                <label>Phone Number</label>
                <Input value={dcfCheckoutParams.consumer.mobileNumber.phoneNumber} name="dcfCheckoutParams.consumer.mobileNumber.phoneNumber" onChange={handlePhoneChange} />
            </Form.Field>
            <Form.Select fluid label="Consumer Country" options={countryCodes} value={dcfCheckoutParams.consumer.countryCode} name="dcfCheckoutParams.consumer.countryCode" onChange={handleOnChange} />
        </Form.Group>  

        <Header as="h2">Button</Header>
        <Form.Group widths='equal'>
        <Form.Select fluid label="Locale" options={locale} defaultValue={buttonParams.locale} name="buttonParams.locale" onChange={handleOnChange} />   
        <Form.Select fluid label="Button Size" options={buttonSize} defaultValue={buttonParams.buttonsize} name="buttonParams.buttonsize" onChange={handleOnChange} />   
        <Form.Select fluid label="Payment Method" options={paymentMethod} defaultValue={buttonParams.paymentmethod} name="buttonParams.paymentmethod" onChange={handleOnChange} />   
        </Form.Group>

      </Form>
    </React.Fragment>
  );
}
